import { useMutation, useQueryClient } from "@tanstack/react-query";
import { backupService } from "@/features/backups/services/backupService";
import { handleApiError, toastMutationSuccess } from "@/lib/error-handler";
import { queryKeys } from "@/lib/query-keys";
import type { Backup, CreateBackupRequest } from "@/types/backup";

function invalidateBackups(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries({ queryKey: queryKeys.backups.all });
}

export function useCreateBackup() {
  const queryClient = useQueryClient();
  return useMutation<Backup, Error, CreateBackupRequest>({
    mutationFn: (payload) => backupService.create(payload),
    onSuccess: (res) => {
      invalidateBackups(queryClient);
      toastMutationSuccess(res, { fallbackMessage: "تم بدء إنشاء النسخة الاحتياطية" });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useRestoreBackup() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) => backupService.restore(id, { confirm: true }),
    onSuccess: () => {
      invalidateBackups(queryClient);
      toastMutationSuccess(undefined, {
        fallbackMessage: "تمت استعادة النسخة الاحتياطية",
      });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useDownloadBackup() {
  return useMutation<void, Error, string>({
    mutationFn: (id) => backupService.download(id),
    onError: (error) => handleApiError(error),
  });
}
